import { render, staticRenderFns } from "./listprovider.vue?vue&type=template&id=37aff538&"
import script from "./listprovider.vue?vue&type=script&lang=js&"
export * from "./listprovider.vue?vue&type=script&lang=js&"
import style0 from "./listprovider.vue?vue&type=style&index=0&id=37aff538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports